import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    margin: '0.8rem 0 2rem'
}))

export const Section = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 300,
    marginBottom: '2rem'
}))

export const Title = styled('h3', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    fontWeight: 700,
    margin: 0
}))

export const Subtitle = styled('h4', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 700,
    margin: '0 0 0.8rem'
}))
